export default __webpack_public_path__ + "static/media/ldap.d64ec08d.jpg";